import { render, staticRenderFns } from "./myPosition.vue?vue&type=template&id=5990aece&scoped=true"
import script from "./myPosition.vue?vue&type=script&lang=js"
export * from "./myPosition.vue?vue&type=script&lang=js"
import style0 from "./myPosition.vue?vue&type=style&index=0&id=5990aece&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990aece",
  null
  
)

export default component.exports